// src/features/policies/api/policyApi.js

import { API_BASE } from "../../../config";

function buildHeaders(apiKey, tenantId) {
  const headers = {
    "Content-Type": "application/json"
  };
  if (apiKey) {
    headers["X-API-KEY"] = apiKey;
  }
  if (tenantId) {
    headers["X-TENANT-ID"] = tenantId;
  }
  const token = localStorage.getItem("token");
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }
  return headers;
}

/**
 * GET /admin/policies/page
 */
export async function listPolicies(
  apiKey,
  tenantId,
  page = 0,
  pageSize = 10,
  search = ""
) {

  const params = new URLSearchParams({
    page,
    pageSize,
    search
  });

  const response = await fetch(
    `${API_BASE}/admin/policies/page?${params}`,
    {
      headers: buildHeaders(apiKey, tenantId)
    }
  );

  if (!response.ok) {
    throw new Error("Failed to load policies");
  }

  return response.json();
}

/**
 * GET policy versions
 */
export async function getPolicyVersions(
  apiKey,
  tenantId,
  policyId,
  page = 0,
  pageSize = 10
) {

  const params = new URLSearchParams({
    page,
    pageSize
  });

  const response = await fetch(
    `${API_BASE}/admin/policies/${policyId}/versions/page?${params}`,
    {
      headers: buildHeaders(apiKey, tenantId)
    }
  );

  if (!response.ok) {
    throw new Error("Failed to load policy versions");
  }

  return response.json();
}

/**
 * Build request payload
 */
function buildPolicyPayload(request) {

  return {

    policyName:
      request.policyName,

    policyDescription:
      request.policyDescription,

    version:
      request.version,

    priority:
      request.priority,

    effect:
      request.effect,

    actions:
      request.actions || [],

    roles:
      request.roles || [],

    resourceScope:
      request.resourceScope || {
        type: "",
        filters: []
      },

    conditions:
      request.conditions || [],

    effectiveFrom:
      request.effectiveFrom ||
      new Date().toISOString(),

    effectiveTo:
      request.effectiveTo || null
  };
}

/**
 * POST /admin/policies
 */
export async function createPolicy(
  apiKey,
  tenantId,
  request
) {

  const payload =
    buildPolicyPayload(request);

  console.log(
    "Create Policy payload:",
    payload
  );

  const response = await fetch(
    `${API_BASE}/admin/policies`,
    {
      method: "POST",
      headers: buildHeaders(
        apiKey,
        tenantId
      ),
      body: JSON.stringify(payload)
    }
  );

  if (!response.ok) {

    const text =
      await response.text();

    throw new Error(
      text || "Policy creation failed"
    );
  }

  return response.json();
}

/**
 * PUT /admin/policies/{policyId}/versions
 */
export async function createPolicyVersion(
  apiKey,
  tenantId,
  policyId,
  request
) {

  const payload =
    buildPolicyPayload(request);

  console.log(
    "Create Version payload:",
    payload
  );

  const response = await fetch(
    `${API_BASE}/admin/policies/${policyId}/versions`,
    {
      method: "PUT",
      headers: buildHeaders(
        apiKey,
        tenantId
      ),
      body: JSON.stringify(payload)
    }
  );

  if (!response.ok) {

    const text =
      await response.text();

    throw new Error(
      text || "Version creation failed"
    );
  }

  return response.json();
}

/**
 * Activate policy
 */
export async function activatePolicy(
  apiKey,
  tenantId,
  policyId
) {

  const response = await fetch(
    `${API_BASE}/admin/policies/${policyId}/activate`,
    {
      method: "POST",
      headers: buildHeaders(
        apiKey,
        tenantId
      )
    }
  );

  if (!response.ok) {
    throw new Error(
      "Activation failed"
    );
  }

  return response.json();
}

/**
 * Deactivate policy
 */
export async function deactivatePolicy(
  apiKey,
  tenantId,
  policyId
) {

  const response = await fetch(
    `${API_BASE}/admin/policies/${policyId}/deactivate`,
    {
      method: "POST",
      headers: buildHeaders(
        apiKey,
        tenantId
      )
    }
  );

  if (!response.ok) {
    throw new Error(
      "Deactivation failed"
    );
  }

  return response.json();
}

/**
 * POST /admin/policies/simulate
 */
export async function simulatePolicy(
  apiKey,
  tenantId,
  simulationRequest
) {
  const response = await fetch(
    `${API_BASE}/admin/policies/simulate`,
    {
      method: "POST",
      headers: buildHeaders(apiKey, tenantId),
      body: JSON.stringify(simulationRequest)
    }
  );

  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || "Simulation failed");
  }

  return response.json();
}